import { Outlet } from "react-router-dom";

/**
 * Company ACTIVE agencies use all permitted menus.
 * Subscription Plans is a normal page, not a redirect trap.
 */
export default function SubscriptionGate() {
  return <Outlet />;
}
